import { environment } from 'src/environments/environment';

export function resolveAvatarUrl(value?: string | null): string | null {
  const url = value?.trim();
  if (!url) return null;
  if (!url.startsWith('/')) return url;

  try {
    return new URL(url, environment.teamApiUrl).toString();
  } catch {
    return url;
  }
}

export function isTeamApiAvatarUrl(value?: string | null): boolean {
  const avatarUrl = resolveAvatarUrl(value);
  const teamApiUrl = environment.teamApiUrl?.trim();
  if (!avatarUrl || !teamApiUrl) return false;

  try {
    return new URL(avatarUrl).origin === new URL(teamApiUrl).origin;
  } catch {
    return false;
  }
}
